import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

import { getFactorScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'

type ScoreCellProps = Pick<
  TableCellProps,
  'className' | 'maxWidth' | 'hasIncreasedHeight'
> & {
  score?: number | null
}

export const ScoreCell = ({
  className,
  maxWidth,
  score,
  hasIncreasedHeight,
}: ScoreCellProps) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box align="center" justify="center" tagName="span">
      <ScoreChip
        size="small"
        score={percentScore(score)}
        theme={getFactorScoreTreshholds(score)}
      />
    </Box>
  </Table.Cell>
)
